export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/company-mails', { params: data.filters || {} })
  },
})
